import { FC } from 'react';

import { GlossaryItem } from '../../types/Glossary';
import { GlossaryListItem } from './GlossaryListItem';

interface Props {
  emptyMessage?: string;
  handleClick: (item: GlossaryItem) => void;
  query: string;
  glossary: GlossaryItem[];
}

export const GlossaryList: FC<Props> = ({
  emptyMessage,
  glossary,
  handleClick,
  query,
}) => {
  if (query.trim() && glossary.length === 0) {
    return <div className="text-neutral-4">{emptyMessage}</div>;
  }

  return (
    <div className="grid-section gap-y-6">
      {glossary.map((item) => (
        <div
          key={item.slug}
          className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3"
        >
          <GlossaryListItem item={item} onClick={() => handleClick(item)} />
        </div>
      ))}
    </div>
  );
};
